package features.auth.ui

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement

object LoginPage {
    fun render(root: HTMLElement) {
        root.innerHTML = ""
        root.append {
            div(classes = "min-h-screen flex items-center justify-center bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900") {
                div(classes = "text-center space-y-8 p-8") {
                    // Logo
                    img(src = "logo.png", classes = "w-32 h-32 mx-auto mb-4")
                    
                    // Title
                    h1(classes = "text-4xl font-bold gradient-text") {
                        +"TeamMate"
                    }
                    p(classes = "text-slate-400 text-lg") {
                        +"Shift Management Made Easy"
                    }
                    
                    // Login Button
                    button(classes = "mt-8 px-8 py-3 bg-gradient-to-r from-brand-cyan to-brand-teal text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-brand-cyan/50 transition-all") {
                        +"Sign in with Google"
                        onClickFunction = { 
                            // Use external function to avoid circular dependency
                            js("window.authFeatureLogin()")
                        }
                    }
                    
                    // Dev Login Button (For Testing)
                    // Dev Login Button (For Testing)
                    /*
                    button(classes = "mt-4 block mx-auto text-sm text-slate-500 hover:text-brand-cyan transition-colors") {
                        +"(Dev) Bypass Login"
                        onClickFunction = { 
                            js("window.devLogin()")
                        }
                    }
                    */
                }
            }
        }
    }
}
